import { SITE_URL } from '@/constants';

export default function HomeSeo() {
  const siteUrl = typeof __SITE_URL__ !== 'undefined' ? __SITE_URL__ : SITE_URL;

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Superbuy Spreadsheet',
            url: siteUrl,
            description:
              'Discover the best Superbuy spreadsheet with trusted shopping links, buying guides, fashion finds, QC tips and safe shopping recommendations.',
            sameAs: ['https://kaspreadsheet.com/'],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Superbuy Spreadsheet',
            url: siteUrl,
            description:
              'Discover the best Superbuy spreadsheet with trusted shopping links, buying guides, and safe shopping recommendations.',
            potentialAction: {
              '@type': 'SearchAction',
              target: siteUrl + '/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Best Superbuy Spreadsheet 2026 | Trusted Links & Buying Guides',
            url: siteUrl + '/',
            description:
              'Discover the best Superbuy spreadsheet with trusted shopping links, buying guides, fashion finds, QC tips and safe shopping recommendations for international buyers.',
            publisher: { '@type': 'Organization', name: 'Superbuy Spreadsheet' },
          }),
        }}
      />
    </>
  );
}